import ItemCard from 'component/item_card/item_card';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
// import { useStyles } from "./style";

function ViewStyleDetail(props) {
    const { listItem, setListItem, shortPopup, styleData, onOpenItem, language, hideButtonOnFirstItem } = props;
    const me = useSelector((state: RootState) => state.userDetail.me);
    const minCount = !shortPopup ? 0 : 1;
    // const classes = useStyles();
    //const [size, setSize] = React.useState("");
    //const [color, setColor] = React.useState("")
    const handleChangeSize = (event, id: string) => {
        const size = event.target.value;
        setListItem(listItem?.map((it) => (it?.id !== id ? it : { ...it, size })));
        //setSize(size);
    };
    const handleChangeColor = (event, id: string) => {
        const color = event.target.value;
        setListItem(listItem?.map((it) => (it?.id !== id ? it : { ...it, color })));
        //setColor(color);
    };

    const handleChangeQuantity = (index: number, value: number) => {
        // console.log(id, type)
        const actNum = value;
        setListItem(
            listItem?.map((it, id) => {
                if (index !== id) return it;
                let quantity = it?.quantity || 0;
                if (actNum > 0) quantity += actNum;
                else if (quantity > minCount) quantity += actNum;
                return { ...it, quantity };
            }),
        );
    };
    return (
        <>
            {listItem.map((item, index) => {
                return (
                    // <div key={index} className={classes.bagItem}>
                    //     <img
                    //         src={item?.data?.images[0]}
                    //         className={classes.itemImg}
                    //         alt=""
                    //         width={84}
                    //         height={100}
                    //     />
                    //     <div className={classes.itemDetail}>
                    //         <Box flex={1}>
                    //             <div className={classes.itemName}>
                    //                 <span>{item?.data?.title}</span>
                    //             </div>
                    //             <div className={classes.itemDes}>
                    //                 <span className={classes.itemDropdown}>
                    //                     Size:
                    //                     <DropDown
                    //                         value={item?.size}
                    //                         handleChange={(e) => handleChangeSize(e, item?.id)}
                    //                         items={item?.data?.sizes}
                    //                     />
                    //                 </span>
                    //                 <span className={classes.itemDropdown}>
                    //                     Color:
                    //                     <DropDown
                    //                         value={item?.color}
                    //                         handleChange={(e) => handleChangeColor(e, item?.id)}
                    //                         items={item?.data?.colors}
                    //                     />
                    //                 </span>
                    //             </div>
                    //         </Box>
                    //         <Box display={"flex"} alignItems={"center"}>
                    //             <span className={classes.itemPrice}>{utils.getPreciseMoney(item?.data?.price)} {item?.data?.currency}</span>
                    //             <StandardQuantityBox
                    //                 id={item?.id}
                    //                 quantity={item?.quantity || 0}
                    //                 handleChangeQuantity={handleChangeQuantity}
                    //                 isDelete={false}
                    //                 theme={'light'}
                    //             />
                    //         </Box>
                    //     </div>
                    // </div>
                    <ItemCard
                        key={index}
                        index={index}
                        item_name={item?.data?.title}
                        image={item?.data?.images ? item?.data?.images[0] : ''}
                        price={item?.data?.price}
                        currency={item?.data?.currency}
                        quantity={item?.quantity || 0}
                        handleChangeQuantity={handleChangeQuantity}
                        isDelete={false}
                        theme={'light'}
                        id={item?.id}
                        sizeList={item?.data?.sizes}
                        sizeValue={item?.size}
                        colorList={item?.data?.colors}
                        colorValue={item?.color}
                        handleChangeSize={handleChangeSize}
                        handleChangeColor={handleChangeColor}
                        isDropdown={true}
                        inStock={item?.data?.inStock}
                        availabilityCheck={false}
                        disableAction={item?.data?.creator === me?.id}
                        listItem={item}
                        supportsWidget={true}
                        styleData={styleData}
                        onOpenItem={onOpenItem}
                        language={language}
                        hideButtonOnFirstItem={!index && hideButtonOnFirstItem}
                    />
                );
            })}
        </>
    );
}

export default ViewStyleDetail;
